var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Table',{attrs:{"border":"","data":_vm.filters,"columns":_vm.tableColumnsFilters,"stripe":""}}),_c('Table',{attrs:{"show-header":false,"border":"","data":_vm.data,"columns":_vm.columns,"stripe":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }